import React, { useContext, useEffect, useState } from "react";
import "./Market_News.css";
import Section_Header_Bar from "../../common_components/section_header_bar/Section_Header_Bar";
import Inner_Footer_Text_Component from "../../common_components/inner_footer_text_component/Inner_Footer_Text_Component";
import { getAllCompany } from "../../../utils/apis/common/Common";
import { MarketNews } from "../../../utils/apis/master/Master";
import { Context } from "../../../utils/context";

const Market_News = () => {
  const { IMG_URL } = useContext(Context);
  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();
  const [showMoreText, setShowMoreText] = useState(false); // Track which item is expanded

  const [category, setCategory] = useState([]);
  const getCompany = async () => {
    const res = await getAllCompany();
    if (res?.success) {
      setCategory(res.data?.data);
    }
  };

  const [marketNews, setMarketNews] = useState([]);
  const getMarketNews = async (id) => {
    const res = await MarketNews(id);
    if (res?.success) {
      setMarketNews(res.data?.data);
    }
  };

  useEffect(() => {
    getCompany();
  }, []);

  useEffect(() => {
    if (category.length > 0) {
      getMarketNews(category[0]?.id);
    }
  }, [category]);

  const truncateText = (text, wordLimit) => {
    const words = text.split(" ");
    if (words.length > wordLimit) {
      return words.slice(0, wordLimit).join(" ") + "...";
    }
    return text;
  };

  return (
    <section className="Market_News">
      <div className="header_div">
        <Section_Header_Bar />
      </div>

      <p className="section_title">Analytics</p>

      <div className="inner_section_box">
        <div className="inner_box">
          <div className="main_data_holder">
            <div className="row ">
              <div className="col-lg-9">
                <div className="analytics_holder">
                  {marketNews?.map((item, index) => {
                    const isExpanded = showMoreText === index;

                   

                    return (
                      <div className="row mb-3 align-items-start " key={index}>
                        <div className="col-xl-2 col-lg-3 col-md-2 col-sm-4 col-6">
                          <div className="right_most_img_holder">
                            <img src={IMG_URL + item?.image} className="img" />
                          </div>
                        </div>
                        <div className="col-xl-10 col-lg-9 col-md-10">
                          <div className="black_box">
                            <div className="name_date_div">
                              <p className="name_text border_right">
                                {item?.name}
                              </p>
                              <p className="name_text">
                                {new Date(item?.createdAt).toLocaleDateString(
                                  "en-GB"
                                )}
                              </p>
                            </div>

                            <p className="title">{item?.title}</p>
                            <p className="subtitle">
                              {htmlToReactParser.parse(
                                isExpanded
                                  ? item?.description
                                  : truncateText(item?.description, 200)
                              )}
                            </p>

                            {/* <p
                              className="read_more_text"
                              onClick={() => {
                                setShowMoreText(isExpanded ? null : index);
                              }}
                            >
                              {isExpanded ? "View Less" : "View More"}
                            </p> */}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="col-lg-3">
                <div className="tags_div">
                  <div className="heading_div">
                    <p className="heading">Tags</p>
                    {category?.map((tag) => {
                      return (
                        <div
                          className="tag_box"
                          key={tag?.id}
                          onClick={() => getMarketNews(tag?.id)}
                        >
                          <p className="tag_text">{tag?.name}</p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer_text">
          <Inner_Footer_Text_Component />
        </div>
      </div>
    </section>
  );
};

export default Market_News;
